var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "edit",
  width: 12,
  height: 12.002,
  viewBox: "0 0 12 12.002"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M11.517,12H.482a.482.482,0,0,1,0-.964H11.517a.482.482,0,0,1,0,.964ZM2.937,9.492a.431.431,0,0,1-.393-.6L3.881,5.741A.432.432,0,0,1,3.972,5.6L9.291.283a.968.968,0,0,1,1.366,0l1.062,1.062a.968.968,0,0,1,0,1.367L6.4,8.03a.432.432,0,0,1-.137.091L3.107,9.457A.436.436,0,0,1,2.937,9.492ZM8.461,2.478h0L4.727,6.212l-.78,1.841,1.84-.78L9.521,3.539,8.461,2.478ZM9.975.963h0l0,0-.83.831L10.2,2.857l.83-.831,0,0L9.975.963Z",
  transform: "translate(0 0)",
  fill: "#fc125e"
})));
export default __webpack_public_path__ + "static/media/editican.6b582807.svg";
export { SvgComponent as ReactComponent };